const getRootDomain = (hostname: string): string => {
    if (hostname === 'localhost') {
        return hostname;
    }
    return hostname.split('.').slice(-2).join('.');
};

export const isSameDomain = (url: string): boolean => {
    try {
        const hostname = new URL(url).hostname;
        return getRootDomain(window.location.hostname) === getRootDomain(hostname);
    } catch {
        return false;
    }
};
